export let everythingSelectedFocused = "lnTmSd";
export default {everythingSelectedFocused};